export default function getDialogData (i18n) {
  return {
    common: {
      error: {
        type: 'alert',
        iconClass: 'icon--dialog-warning',
        title: i18n.t('dialog.common.title'),
        description: i18n.t('dialog.common.desc')
      }
    },
    dashboard: {

    },
    report: {
      reportRequest: {
        success: {
          type: 'alert',
          iconClass: 'icon--check-green-size50',
          title: i18n.t('dialog.report.reportRequested.title'),
          description: i18n.t('dialog.report.reportRequested.description')
        },
        duplicate: {
          type: 'alert',
          iconClass: 'icon--dialog-confirm',
          title: i18n.t('dialog.report.duplicate.title'),
          description: i18n.t('dialog.report.duplicate.description')
        },
        duplicateMashup: {
          type: 'mashup',
          iconClass: 'icon--dialog-confirm',
          title: i18n.t('dialog.report.duplicateMashup.title'),
          description: i18n.t('dialog.report.duplicateMashup.description')
        },
        sysError: {
          type: 'alert',
          iconClass: 'icon--dialog-warning',
          title: i18n.t('dialog.report.sysError.title'),
          description: i18n.t('dialog.report.sysError.description')
        },
        jamError: {
          type: 'alert',
          iconClass: 'icon--dialog-warning',
          title: i18n.t('dialog.report.jamError.title'),
          description: i18n.t('dialog.report.jamError.description')
        }
      },
      paymentFailed: {
        type: 'alert',
        iconClass: 'icon--dialog-warning',
        title: i18n.t('dialog.report.paymentFailed.title'),
        description: ''
      },
      changeOnOff: {
        on: {
          type: 'confirm',
          iconClass: 'icon--dialog-warning',
          title: i18n.t('dialog.report.changeOnOff.on.title'),
          description: i18n.t('dialog.report.changeOnOff.on.description')
        },
        off: {
          type: 'confirm',
          iconClass: 'icon--dialog-warning',
          title: i18n.t('dialog.report.changeOnOff.off.title'),
          description: i18n.t('dialog.report.changeOnOff.off.description')
        }
      },
      changeSuccess: {
        on: {
          type: 'alert',
          iconClass: 'icon--check-green-size50',
          title: i18n.t('dialog.report.changeSuccess.on.title'),
          description: i18n.t('dialog.report.changeSuccess.on.description')
        },
        off: {
          type: 'alert',
          iconClass: 'icon--check-green-size50',
          title: i18n.t('dialog.report.changeSuccess.off.title'),
          description: i18n.t('dialog.report.changeSuccess.off.description')
        }
      },
      tokenLimit: {
        type: 'alert',
        iconClass: 'icon--dialog-warning',
        title: i18n.t('dialog.report.tokenLimit.title'),
        description: i18n.t('dialog.report.tokenLimit.description')
      }
    },
    userInfo: {
      myInformationEditSuccess: {
        type: 'alert',
        iconClass: 'icon--check-green-size50',
        title: i18n.t('dialog.userInfo.myInformationEditSuccess.title'),
        description: i18n.t('dialog.userInfo.myInformationEditSuccess.desc')
      },
      ipBlockItemDelete: {
        type: 'confirm',
        iconClass: 'icon--dialog-warning',
        description: i18n.t('dialog.userInfo.ipBlockItemDelete.desc')
      },
      ipBlockConfirmEdit: {
        type: 'confirm',
        iconClass: 'icon--dialog-confirm',
        title: i18n.t('dialog.userInfo.ipBlockConfirmEdit.title'),
        description: i18n.t('dialog.userInfo.ipBlockConfirmEdit.desc')
      },
      registerCard: {
        type: 'confirm',
        iconClass: 'icon--dialog-card',
        title: i18n.t('dialog.userInfo.registerCard.title'),
        description: i18n.t('dialog.userInfo.registerCard.desc')
      }
    },
    plan: {
      registerCardFailed: {
        type: 'alert',
        iconClass: 'icon--dialog-warning',
        title: i18n.t('dialog.plan.registerCardFailed.title'),
        description: i18n.t('dialog.plan.registerCardFailed.desc')
      },
      changeCardFailed: {
        type: 'alert',
        iconClass: 'icon--dialog-warning',
        title: i18n.t('dialog.plan.changeCardFailed.title'),
        description: i18n.t('dialog.plan.changeCardFailed.desc')
      },
      noCurrentPlanFound: {
        type: 'alert',
        iconClass: 'icon--dialog-warning',
        title: i18n.t('dialog.plan.noCurrentPlanFound.title'),
        description: i18n.t('dialog.plan.noCurrentPlanFound.desc')
      },
      pvEmpty: {
        type: 'pvEmpty',
        iconClass: 'icon--dialog-warning',
        title: i18n.t('dialog.plan.pvEmpty.title'),
        description: i18n.t('dialog.plan.pvEmpty.desc')
      },
      pvCompleted: {
        type: 'alert',
        iconClass: 'icon--check-green-size50',
        title: i18n.t('dialog.plan.pvCompleted.title'),
        description: i18n.t('dialog.plan.pvCompleted.desc')
      },
      planCompleted: {
        type: 'alert',
        iconClass: 'icon--check-green-size50',
        title: i18n.t('dialog.plan.planCompleted.title'),
        description: i18n.t('dialog.plan.planCompleted.desc')
      },
      planScheduleCompleted: {
        type: 'alert',
        iconClass: 'icon--check-green-size50',
        title: i18n.t('dialog.plan.planScheduleCompleted.title'),
        description: i18n.t('dialog.plan.planScheduleCompleted.desc')
      },
      planEndInactivate: {
        type: 'alert',
        iconClass: 'icon--check-green-size50',
        title: i18n.t('dialog.plan.planEndInactivate.title'),
        description: i18n.t('dialog.plan.planEndInactivate.desc')
      },
      planEndInactivateFailed: {
        type: 'alert',
        iconClass: 'icon--dialog-warning',
        title: i18n.t('dialog.plan.planEndInactivateFailed.title'),
        description: i18n.t('dialog.plan.planEndInactivateFailed.desc')
      },
      planDuplicate: {
        type: 'alert',
        iconClass: 'icon--dialog-warning',
        title: i18n.t('dialog.plan.planDuplicate.title'),
        description: i18n.t('dialog.plan.planDuplicate.desc')
      }
    },
    journey: {
      invalidRequest: {
        type: 'alert',
        iconClass: 'icon--dialog-warning',
        title: i18n.t('dialog.journey.invalidRequest.title'),
        description: i18n.t('dialog.journey.invalidRequest.desc')
      },
      changePeriodResetUtm: {
        type: 'confirm',
        iconClass: 'icon--dialog-warning',
        title: i18n.t('dialog.journey.changePeriodResetUtm.title'),
        description: i18n.t('dialog.journey.changePeriodResetUtm.desc')
      }
    },
    survey: {
      editCancel: {
        type: 'confirm',
        iconClass: 'icon--dialog-warning',
        title: i18n.t('dialog.survey.editCancel.title'),
        description: i18n.t('dialog.survey.editCancel.desc')
      }
    },
    tracking: {
      stopTracking: {
        type: 'confirm',
        iconClass: 'icon--dialog-exit',
        title: i18n.t('dialog.tracking.stopTracking.title')
      },
      stopTrackingWithDesc: {
        type: 'confirm',
        iconClass: 'icon--dialog-exit',
        title: i18n.t('dialog.tracking.stopTrackingWithDesc.title'),
        description: i18n.t('dialog.tracking.stopTrackingWithDesc.desc')
      }
    }
  }
}
